var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{staticClass:"largeTextField",attrs:{"data-cy":_vm.config.dataCy,"options":_vm.editorOptionAvail},model:{value:(_vm.inputVal[_vm.config.vModel]),callback:function ($$v) {_vm.$set(_vm.inputVal, _vm.config.vModel, $$v)},expression:"inputVal[config.vModel]"}})
}
var staticRenderFns = []

export { render, staticRenderFns }